module.exports = __webpack_public_path__ + "738d403592e8def6435d8cac78d095e0.svg";